module.exports = __webpack_public_path__ + "static/media/logo-compras.ce375a8d.png";